import script from "./welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome.vue?vue&type=script&setup=true&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=d2661850&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2661850"]])

export default __exports__